/**
 *
 * @page 公共调用预览音频
 *
 */

import { View, Audio, Video } from '@tarojs/components';
import { AtIcon } from 'taro-ui';
import { observer, inject } from 'mobx-react';
import Taro from '@tarojs/taro';
import './previewMedia.scss';

function PreviewMedia(props) {
    const { onClose } = props;
    const {
        config: { type = '', src = '', poster = '' },
        mediaVisible,
    } = props.previewMedia;
    const video = useRef();

    const play = () => {
        if (type === 'video') {
            video.current = document.getElementById('video-player');
            try {
                function fetchVideoAndPlay() {
                    Taro.showLoading({ title: intl.get('commonPage.loading') });
                    fetch(src)
                        .then(response => {
                            Taro.hideLoading();
                            return response.blob();
                        })
                        .then(blob => {
                            video.current.srcObject = blob;
                            return video.current.play();
                        })
                        .catch(e => {
                            Taro.hideLoading();
                            console('error', e);
                            // Video playback failed ;(
                        });
                }
                fetchVideoAndPlay();
            } catch (error) {
                console.log('err', error);
            }
        }
    };

    useEffect(() => {
        if (!mediaVisible) {
            return;
        }
        play();
    }, [mediaVisible]);

    const CONTENT = {
        video: (
            <Video
                id="video-player"
                enablePlayGesture
                showProgress
                enableProgressGesture
                showFullscreenBtn={false}
                autoplay
                poster={mediaVisible ? poster : null}
                src={mediaVisible ? src : null}
            ></Video>
        ),
        audio: <Audio autoplay src={src}></Audio>,
    };

    return (
        mediaVisible && (
            <View className="preview-media-mark">
                <AtIcon
                    className="close-icon"
                    onClick={onClose}
                    value="close"
                    color="#EFEFEF"
                ></AtIcon>
                {CONTENT[type]}
            </View>
        )
    );
}

export default inject('previewMedia')(observer(PreviewMedia));
